import { focusVisible } from "@mittwald/flow-styles/dist/mixins/focusVisible";
import { color, size, spacing, } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { Box } from "../../Box";
import { Icon, Text } from "./index";
export const Container = styled(Box) `
  text-align: center;
  display: inline-block;
  flex-wrap: nowrap;
  cursor: default;
  user-select: none;
  color: ${color.font.text.default};

  &.hasAction {
    cursor: pointer;
  }

  &.isExecuting {
    cursor: wait;
  }

  &.hasAction:hover,
  &.hasAction.hover,
  &.active {
    ${Text}, ${Icon} {
      color: ${color.font.link.default};
    }
  }

  &.hasAction:hover,
  &.hasAction.hover {
    background-color: ${color.background.selectableBox.hovered};
  }

  &.hasAction:hover:not(.active),
  &.hasAction.hover:not(.active) {
    ${Text}, ${Icon} {
      color: ${color.font.text.default};
    }
  }

  &.active {
    background-color: ${color.background.selectableBox.selected};

    ${Text} {
      font-weight: bold;
    }
  }

  &:not(.active) {
    background-color: ${color.background.input.default};
  }

  &.react-loading-skeleton {
    height: calc(${spacing.insetSquish.s.y} + ${size.lineHeight.text.squished});
  }

  ${focusVisible}
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGFpbmVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQmFkZ2Uvc3R5bGVkL0NvbnRhaW5lci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsWUFBWSxFQUFFLE1BQU0sZ0RBQWdELENBQUM7QUFDOUUsT0FBTyxFQUNMLEtBQUssRUFDTCxJQUFJLEVBQ0osT0FBTyxHQUNSLE1BQU0sZ0RBQWdELENBQUM7QUFDeEQsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUM7QUFDdkMsT0FBTyxFQUFFLEdBQUcsRUFBRSxNQUFNLFdBQVcsQ0FBQztBQUNoQyxPQUFPLEVBQUUsSUFBSSxFQUFFLElBQUksRUFBRSxNQUFNLFNBQVMsQ0FBQztBQUVyQyxNQUFNLENBQUMsTUFBTSxTQUFTLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFBOzs7Ozs7V0FNekIsS0FBSyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTzs7Ozs7Ozs7Ozs7OztNQWE1QixJQUFJLEtBQUssSUFBSTtlQUNKLEtBQUssQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU87Ozs7Ozt3QkFNZCxLQUFLLENBQUMsVUFBVSxDQUFDLGFBQWEsQ0FBQyxPQUFPOzs7OztNQUt4RCxJQUFJLEtBQUssSUFBSTtlQUNKLEtBQUssQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU87Ozs7O3dCQUtkLEtBQUssQ0FBQyxVQUFVLENBQUMsYUFBYSxDQUFDLFFBQVE7O01BRXpELElBQUk7Ozs7Ozt3QkFNYyxLQUFLLENBQUMsVUFBVSxDQUFDLEtBQUssQ0FBQyxPQUFPOzs7O21CQUluQyxPQUFPLENBQUMsV0FBVyxDQUFDLENBQUMsQ0FBQyxDQUFDLE1BQU0sSUFBSSxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsUUFBUTs7O0lBR3pFLFlBQVk7Q0FDZixDQUFDIn0=